'use strict';

var _extends = require('../../../../@babel/runtime/helpers/esm/extends.js');
var classCallCheck = require('../../../../@babel/runtime/helpers/esm/classCallCheck.js');
var createClass = require('../../../../@babel/runtime/helpers/esm/createClass.js');
var React = require('react');
var jss_esm = require('../../../../jss/dist/jss.esm.js');
var createGenerateClassName = require('../createGenerateClassName/createGenerateClassName.js');
var StylesProvider = require('../StylesProvider/StylesProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var ServerStyleSheets = /*#__PURE__*/function () {
  function ServerStyleSheets() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    classCallCheck(this, ServerStyleSheets);

    this.options = options;
  }

  createClass(ServerStyleSheets, [{
    key: "collect",
    value: function collect(children) {
      // This is needed in order to deduplicate the injection of CSS in the page.
      var sheetsManager = new Map(); // This is needed in order to inject the critical CSS.

      this.sheetsRegistry = new jss_esm.SheetsRegistry(); // A new class name generator

      var generateClassName = createGenerateClassName();
      return /*#__PURE__*/React__default["default"].createElement(StylesProvider["default"], _extends({
        sheetsManager: sheetsManager,
        serverGenerateClassName: generateClassName,
        sheetsRegistry: this.sheetsRegistry
      }, this.options), children);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.sheetsRegistry ? this.sheetsRegistry.toString() : '';
    }
  }, {
    key: "getStyleElement",
    value: function getStyleElement(props) {
      return React__default["default"].createElement('style', _extends({
        id: 'jss-server-side',
        key: 'jss-server-side',
        dangerouslySetInnerHTML: {
          __html: this.toString()
        }
      }, props));
    }
  }]);

  return ServerStyleSheets;
}();

module.exports = ServerStyleSheets;
